import React from 'react'
import { useState, useCallback } from "react"
import {
  format,
  addDays,
  subDays,
  addHours,
  subHours,
  addMinutes,
  subMinutes,
  setSeconds
} from 'date-fns'

import NumberPicker from 'app/inputs/NumberPicker'

export default ({ value, onChange }) => {
  const addDay = useCallback(() => {
    const newValue = addDays(setSeconds(value, 0), 1);
    onChange(newValue);
  }, [value])

  const subDay = useCallback(() => {
    const newValue = subDays(setSeconds(value, 0), 1);
    onChange(newValue);
  }, [value])

  const addHour = useCallback(() => {
    const newValue = addHours(setSeconds(value, 0), 1);
    onChange(newValue);
  }, [value])

  const subHour = useCallback(() => {
    const newValue = subHours(setSeconds(value, 0), 1);
    onChange(newValue);
  }, [value])

  const addMinute = useCallback(() => {
    const newValue = addMinutes(setSeconds(value, 0), 1);
    onChange(newValue);
  }, [value])

  const subMinute = useCallback(() => {
    const newValue = subMinutes(setSeconds(value, 0), 1);
    onChange(newValue);
  }, [value])

  return <>
           <div className="text-center mb-1 text-gray-500">{ format(value, 'dd/MM/y HH:mm') }</div>

           <div className="frow gap-2 items-center mb-d">
             <NumberPicker label='Day' up={ addDay } down={ subDay } >
               <div className="text-3xl font-digital">{ format(value, 'd') }</div>
             </NumberPicker>
             <NumberPicker label='Hours' up={ addHour } down={ subHour } >
               <div className="text-3xl font-digital">{ format(value, 'HH') }</div>
             </NumberPicker>
             <NumberPicker label='Minutes' up={ addMinute } down={ subMinute } >
               <div className="text-3xl font-digital">{ format(value, 'mm') }</div>
             </NumberPicker>
           </div>
         </>
}
